import commonConstant from '../../common/_commonConstant';
import { dateDDMMYYFormat } from '../FormatDate/FormatDate';
import { vehicleLicensePlate } from '../vehicleLicensePlate/vehicleLicensePlate';

export const carImage = getParkingStatus => {
  try {
    return getParkingStatus.parkingImage.parkingImageURL ? getParkingStatus.parkingImage.parkingImageURL : commonConstant.dummyCarImg;
  } catch (error) {
    return commonConstant.dummyCarImg;
  }
};

export const timeIn = getParkingStatus => {
  try {
    return getParkingStatus.parking.parkingTimeIn ? new Date(getParkingStatus.parking.parkingTimeIn).setHours(new Date(getParkingStatus.parking.parkingTimeIn).getHours()) : null;
  } catch (error) {
    return null;
  }
};

export const isParkingOverTime = getParkingStatus => {
  try {
    return getParkingStatus.currentPayment.paymentTotalParkingFeeMinutes > 0 ? true : false;
  } catch (error) {
    return false;
  }
};

export const isMember = (getParkingStatus, buildingID) => {
  try {
    if (getParkingStatus.customer.customerType === commonConstant.customerTypeMember && getParkingStatus.memberBuilding.buildingID === buildingID) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const parkingTimeTotal = getParkingStatus => {
  try {
    return timeIn(getParkingStatus) ? new Date() - timeIn(getParkingStatus) : null;
  } catch (error) {
    return null;
  }
};

export const freeParkingTimeTotal = getParkingStatus => {
  try {
    let sum = 0;

    if (getParkingStatus.previousPayment) {
      getParkingStatus.previousPayment.forEach(item => {
        sum += item.paymentTotalRedemptionMinutes;
        sum += item.paymentTotalBuildingFreeParkingMinutes;
      });
    }

    return sum + getParkingStatus.currentPayment.paymentTotalRedemptionMinutes + getParkingStatus.currentPayment.paymentTotalBuildingFreeParkingMinutes - sumFreeParkingTime(getParkingStatus);
  } catch (error) {
    return null;
  }
};

export const isOverdue = getParkingStatus => {
  try {
    return (getParkingStatus.currentPayment.paymentTotalParkingFeeAmount + getParkingStatus.currentPayment.paymentTotalOvernightFeeAmount) > 0 ? true : false;
  } catch (error) {
    return null;
  }
};

export const historyPayment = getParkingStatus => {
  try {
    return getParkingStatus.previousPayment.length > 0 ? true : false;
  } catch (error) {
    return null;
  }
};

export const sumFreeParkingTime = getParkingStatus => {
  try {
    let sum = 0;

    getParkingStatus.previousPayment.forEach(item => {
      sum += item.paymentTotalBuildingFreeParkingMinutes;
    });

    return sum;
  } catch (error) {
    return 0;
  }
};

export const parkingUntil = getParkingStatus => {
  try {
    return new Date(timeIn(getParkingStatus)).setMinutes(
      new Date(timeIn(getParkingStatus)).getMinutes() +
      sumParkingTime(getParkingStatus) +
      getParkingStatus.currentPayment.paymentTotalBuildingFreeParkingMinutes +
      getParkingStatus.currentPayment.paymentTotalRedemptionMinutes -
      (getParkingStatus.currentPayment.paymentTotalRedemptionMinutes > 0 ? sumFreeParkingTime(getParkingStatus) : 0),
    );
  } catch (error) {
    return null;
  }
};

export const parkingOverTime = getParkingStatus => {
  try {
    return new Date() - parkingUntil(getParkingStatus);
  } catch (error) {
    return null;
  }
};

export const totalFeeAmount = getParkingStatus => {
  try {
    return getParkingStatus.currentPayment.paymentTotalFeeAmount ? getParkingStatus.currentPayment.paymentTotalFeeAmount : null;
  } catch (error) {
    return null;
  }
};

export const parkingID = getParkingStatus => {
  try {
    return getParkingStatus.parkingID ? getParkingStatus.parkingID : getParkingStatus.parking.parkingID ? getParkingStatus.parking.parkingID : null;
  } catch (error) {
    return null;
  }
};

export const sumParkingTime = getParkingStatus => {
  try {
    let sum = 0;

    if (getParkingStatus.previousPayment) {
      getParkingStatus.previousPayment.forEach(item => {
        sum += item.paymentTotalRedemptionMinutes;
        sum += item.paymentTotalBuildingFreeParkingMinutes;
        sum += item.paymentTotalParkingFeeMinutes;
      });
    }

    return sum;
  } catch (error) {
    return 0;
  }
};

export const isAlreadyExist = getParkingStatusById => {
  try {
    const status = getParkingStatusById.parkingStatus ? getParkingStatusById.parkingStatus : getParkingStatusById.parking.parkingStatus ? getParkingStatusById.parking.parkingStatus : null;

    return status === commonConstant.parkingStatusOut ? true : false;
  } catch (error) {
    return null;
  }
};

export const parkingTimeIn = getParkingStatusById => {
  try {
    const timeIn = getParkingStatusById.parkingTimeIn ? getParkingStatusById.parkingTimeIn : getParkingStatusById.parking.parkingTimeIn ? getParkingStatusById.parking.parkingTimeIn : null;

    return (timeIn ? new Date(timeIn).setHours(new Date(timeIn).getHours()) : false);
  } catch (error) {
    return null;
  }
};

export const parkingTimeOut = getParkingStatusById => {
  try {
    return getParkingStatusById.parkingTimeOut ? new Date(getParkingStatusById.parkingTimeOut).setHours(new Date(getParkingStatusById.parkingTimeOut).getHours()) : false;
  } catch (error) {
    return null;
  }
};

export const vehicleProvince = getParkingStatusById => {
  try {
    if (vehicleLicensePlate(getParkingStatusById) === '00000') {
      return null;
    }
    return (
      getParkingStatusById.vehicleProvince ?
        getParkingStatusById.vehicleProvince
        : getParkingStatusById.vehicle.vehicleProvince ?
          getParkingStatusById.vehicle.vehicleProvince
          : null
    );
  } catch (error) {
    return null;
  }
};

export const vehicleType = getParkingStatusById => {
  try {
    return getParkingStatusById.vehicleType || getParkingStatusById.vehicle.vehicleType ? getParkingStatusById.vehicleType || getParkingStatusById.vehicle.vehicleType : null;
  } catch (error) {
    return null;
  }
};

export const vehicleBrand = getParkingStatusById => {
  try {
    if (vehicleLicensePlate(getParkingStatusById) === '00000') {
      return null;
    }
    return getParkingStatusById.vehicle.vehicleBrand ? getParkingStatusById.vehicle.vehicleBrand : null;
  } catch (error) {
    return null;
  }
};


export const vehicleColor = getParkingStatusById => {
  try {
    if (vehicleLicensePlate(getParkingStatusById) === '00000') {
      return null;
    }
    return getParkingStatusById.vehicle.vehicleColor ? getParkingStatusById.vehicle.vehicleColor : null;
  } catch (error) {
    return null;
  }
};


export const vehicleModel = getParkingStatusById => {
  try {
    if (vehicleLicensePlate(getParkingStatusById) === '00000') {
      return null;
    }
    return getParkingStatusById.vehicle.vehicleModel ? getParkingStatusById.vehicle.vehicleModel : null;
  } catch (error) {
    return null;
  }
};


export const vehicleYear = getParkingStatusById => {
  try {
    if (vehicleLicensePlate(getParkingStatusById) === '00000') {
      return null;
    }
    return getParkingStatusById.vehicle.vehicleModelYear ? getParkingStatusById.vehicle.vehicleModelYear : null;
  } catch (error) {
    return null;
  }
};

export const redeemTotalHr = getParkingStatusById => {
  try {
    let sum = 0;

    if (getParkingStatusById.redeem && getParkingStatusById.redeem.length > 0) {
      getParkingStatusById.redeem.forEach(element => sum += element.tenantParkingPackage.parkingPackageHours);
    }
    return sum;
  } catch (error) {
    return 0;
  }
};

export const redeemRef = getParkingStatusById => {
  try {
    let ref = '';

    if (getParkingStatusById.redeem && getParkingStatusById.redeem.length > 0) {
      getParkingStatusById.redeem.forEach(element => ref = `${ref ? `${ref}/` : ''}${element.tenantParkingPackage.parkingPackageRefCode}`);
    }
    return ref;
  } catch (error) {
    return null;
  }
};

export const paymentType = getParkingStatusById => {
  try {
    return getParkingStatusById.paymentSourceOfFund === commonConstant.paymentMethodCash && getParkingStatusById.paymentType === commonConstant.roleCashier ? commonConstant.paymentMethodCash : 'EZY Pay';
  } catch (error) {
    return null;
  }
};

export const paymentTotalFeeAmount = getParkingStatus => {
  try {
    return (
      getParkingStatus.paymentTotalParkingFeeAmount || getParkingStatus.paymentTotalParkingFeeAmount === 0 ?
        getParkingStatus.paymentTotalParkingFeeAmount
        : getParkingStatus.currentPayment.paymentTotalParkingFeeAmount || getParkingStatus.currentPayment.paymentTotalParkingFeeAmount === 0 ?
          getParkingStatus.currentPayment.paymentTotalParkingFeeAmount
          : null
    );
  } catch (error) {
    return null;
  }
};

export const calculateAmount = data => {
  try {        
    return (paymentTotalFeeAmount(data) || paymentTotalFeeAmount(data) === 0) ? ((paymentTotalFeeAmount(data) * 100) / (data.paymentVatRatePercentage === 0 ? 100 : data.paymentVatRatePercentage)) : null;
  } catch (error) {
    return null;
  }
};

export const calculateOvernight = data => {
  try {
    return (overnightAmount(data) || overnightAmount(data) === 0) ? ((overnightAmount(data) * 100) / (data.paymentVatRatePercentage === 0 ? 100 : data.paymentVatRatePercentage)) : null;
  } catch (error) {
    return null;
  }
};

export const calculateVat = data => {
  try {
    let sum = 0;

    if (paymentTotalFeeAmount(data) || paymentTotalFeeAmount(data) === 0) {
      sum += (paymentTotalFeeAmount(data) - calculateAmount(data));
    }
    if (calculateOvernight(data) || calculateOvernight(data) === 0) {
      sum += (overnightAmount(data) - calculateOvernight(data));
    }

    return sum;
  } catch (error) {
    return null;
  }
};

export const paymentTotalAmount = getParkingStatus => {
  try {
    const payment = getParkingStatus.currentPayment ? getParkingStatus.currentPayment : getParkingStatus;

    if (
      (payment.paymentTotalParkingFeeAmount || payment.paymentTotalParkingFeeAmount === 0) &&
      (payment.paymentTotalOvernightFeeAmount || payment.paymentTotalOvernightFeeAmount === 0)
    ) {
      return (payment.paymentTotalParkingFeeAmount + payment.paymentTotalOvernightFeeAmount);
    } else if (payment.paymentTotalOvernightFeeAmount || payment.paymentTotalOvernightFeeAmount === 0) {
      return (payment.paymentTotalOvernightFeeAmount);
    } else if (payment.paymentTotalParkingFeeAmount || payment.paymentTotalParkingFeeAmount === 0) {
      return (payment.paymentTotalParkingFeeAmount);
    }

    return null;
  } catch (error) {
    return null;
  }
};

export const parkingAmount = getParkingStatus => {
  try {
    return (
      (getParkingStatus.currentPayment.paymentTotalParkingFeeAmount || getParkingStatus.currentPayment.paymentTotalParkingFeeAmount === 0) ?
        getParkingStatus.currentPayment.paymentTotalParkingFeeAmount
        : null
    );
  } catch (error) {
    return null;
  }
};

export const overnightAmount = getParkingStatus => {
  try {
    return (
      (getParkingStatus.paymentTotalOvernightFeeAmount || getParkingStatus.paymentTotalOvernightFeeAmount === 0) ?
        (getParkingStatus.paymentTotalOvernightFeeAmount)
        : (getParkingStatus.currentPayment.paymentTotalOvernightFeeAmount || getParkingStatus.currentPayment.paymentTotalOvernightFeeAmount === 0) ?
          (getParkingStatus.currentPayment.paymentTotalOvernightFeeAmount)
          : null
    );
  } catch (error) {
    return null;
  }
};

export const findHaveOvernight = getParkingStatusById => {
  try {
    let check = false;

    for (let i = 0; i < getParkingStatusById.payment.length; i++) {
      if (getParkingStatusById.payment[i].paymentTotalOvernightFeeAmount) {
        check = true;
      }
    }

    return check;
  } catch (error) {
    return null;
  }
};

export const checkAddDefaultFreeParkingMinutes = getParkingStatus => {
  try {
    let checkRedeem = false;

    for (let index = 0; index < getParkingStatus.previousPayment.length; index++) {
      if (getParkingStatus.previousPayment[index].paymentTotalRedemptionMinutes) {
        checkRedeem = true;
        break;
      }
    }

    return checkRedeem;
  } catch (error) {
    return true;
  }
};

export const summaryDiscount = getParkingStatus => {
  try {
    if (!checkAddDefaultFreeParkingMinutes(getParkingStatus)) {
      return getParkingStatus.currentPayment.paymentTotalRedemptionMinutes - sumFreeParkingTime(getParkingStatus);
    }

    return getParkingStatus.currentPayment.paymentTotalRedemptionMinutes ? getParkingStatus.currentPayment.paymentTotalRedemptionMinutes : getParkingStatus.currentPayment.paymentTotalBuildingFreeParkingMinutes;
  } catch (error) {
    return true;
  }
};

export const parkingDate = getParkingStatus => {
  try {
    const date = new Date().setHours(0,0,0,0);
    const parkingInDate = new Date(getParkingStatus.parkingTimeIn).setHours(0,0,0,0);
    if (parkingInDate === date) {
      return 'วันนี้';
    } else if (parkingInDate === (new Date(date).setDate(new Date(date).getDate() - 1))) {
      return 'เมื่อวาน';
    }
    return dateDDMMYYFormat(getParkingStatus.parkingTimeIn);
  } catch (error) {
    return null;
  }
};
